export const summaryRows: Array<[string, boolean, string, string]> = [
  ['6 tomos completos', true, 'Incluidos', 'Incluidos'],
  ['4 bonos estratégicos', true, 'Incluidos', 'Incluidos'],
  ['150 proyectos culturales listos', true, 'Incluidos', 'Incluidos'],
  ['Banco completo de evaluaciones', true, '56 instrumentos', '56 instrumentos'],
  ['80 formularios editables', true, 'Incluidos', 'Incluidos'],
  ['300 actividades para el aula', true, 'Incluidas', 'Incluidas'],
  ['IA avanzada y emprendedurismo', false, 'No incluido', '80+ prompts + Framework GESTIO-IA'],
  ['Comunicación digital avanzada', false, 'No incluida', 'Sistema CULTURA 360° + Reels + Analytics'],
  ['Guías regionales del interior', false, 'No incluidas', 'NOA, NEA, Cuyo, Patagonia, Pampa y Litoral'],
  ['Estrategias de emprendedurismo', false, 'No incluidas', '6 arquetipos + Canvas + Plan 90 días'],
  ['Financiamiento del interior', false, 'No incluido', 'Negociación con municipios + patrocinio local'],
  ['Patrimonio regional', false, 'No incluido', 'Turismo cultural + inventario patrimonial'],
  ['Acceso de por vida y actualizaciones', true, 'Incluido', 'Incluido'],
  ['Garantía de 7 días', true, 'Sin preguntas', 'Sin preguntas'],
];
